<template>
  <LazyHydrate when-idle>
    <HomeContent />
  </LazyHydrate>
  <LazyHydrate when-visible>
    <LazyHomeInfo />
  </LazyHydrate>

  <LazyHydrate when-visible>
    <LazyHomeProducts />
  </LazyHydrate>

  <LazyHydrate when-visible>
    <LazyHomePossibilities />
  </LazyHydrate>

  <LazyHydrate when-visible>
    <LazyHomeComments />
  </LazyHydrate>

  <LazyHydrate when-visible>
    <LazyHomeLicenses />
  </LazyHydrate>

  <LazyHydrate when-visible>
    <LazyHomeQuestions />
  </LazyHydrate>
</template>

<script>
export default defineComponent({
  setup() {

    useHead({
      script: [
        {
          type: 'application/ld+json',
          body: true,
          defer: true,
          innerHTML:
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "ImageObject",
                "@id": "https://navatel.ir/#/schema/logo/image",
                "inLanguage": "fa-IR",
                "url": "https://navatel.ir/favicon.png",
                "contentUrl": "https://navatel.ir/favicon.png",
                "width": 200,
                "height": 200,
                "caption": "نواتل"
              },
              {
                "@type": [
                  "WebSite",
                  "WebPage"
                ],
                "@id": "https://navatel.ir/#/website_webpage",
                "inLanguage": "fa-IR",
                "url": "https://navatel.ir/",
                "name": "نواتل - تنها سرویس ارتباطات یکپارچه ابری در ایران",
                "alternateName": [
                  "نواتل",
                  "Navatel"
                ],
                "description": "نواتل سرویس یکپارچه ارتباطات ابری با اپلیکیشن اختصاصی و بدون محدودیت در ایران",
                "about": {
                  "@id": "https://navatel.ir/#/about"
                },
                "image": {
                  "@id": "https://navatel.ir/#/schema/logo/image"
                },
                "thumbnailUrl": "https://navatel.ir/favicon.png",
                "datePublished": "2023-01-01T03:30:00+00:00",
                "dateModified": "2023-01-01T03:30:00+00:00",
                "publisher": {
                  "@id": "https://navatel.ir/#/publisher"
                },
                "copyrightHolder": {
                  "@type": "Corporation",
                  "name": "https://navatel.ir"
                },
                "creator": {
                  "@type": "Corporation",
                  "name": "https://navatel.ir"
                },
                "potentialAction": [
                  {
                    "@type": "SearchAction",
                    "target": {
                      "@type": "EntryPoint",
                      "urlTemplate": "https://navatel.ir/?s={search_term_string}"
                    },
                    "query-input": "required name=search_term_string"
                  }
                ],
                "sameAs": [
                  "https://linkedin.com/company/mynavatel/",
                  "https://instagram.com/navatel.ir",
                  "https://aparat.com/Navatel"
                ]
              },
              {
                "@type": [
                  "Organization",
                  "Corporation"
                ],
                "@id": "https://navatel.ir/#/organization_corporation",
                "url": "https://navatel.ir/",
                "name": "نواتل - تنها سرویس ارتباطات یکپارچه ابری در ایران",
                "alternateName": [
                  "نواتل",
                  "Navatel"
                ],
                "legalName": "شبکه گستران آریا سامانه",
                "description": "نواتل سرویس یکپارچه ارتباطات ابری با اپلیکیشن اختصاصی و بدون محدودیت در ایران",
                "image": {
                  "@id": "https://navatel.ir/#/schema/logo/image"
                },
                "logo": "https://navatel.ir/favicon.png",
                "email": "office@sgas.ir",
                "contactPoint": {
                  "@type": "ContactPoint",
                  "telephone": "+982182800000",
                  "contactType": "customer service",
                  "areaServed": "IR",
                  "availableLanguage": "Persian"
                },
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "Tehran Province, Tehran, District 7, Khajeh Nasir Tousi St, No. 247",
                  "addressLocality": "Tehran, Iran",
                  "postalCode": "1611613611",
                  "areaServed": {
                    "@type": "Place",
                    "openingHoursSpecification":[
                      {
                        "dayOfWeek": "https://schema.org/Saturday",
                        "opens":  "09:00",
                        "closes":  "18:00"
                      },
                      {
                        "dayOfWeek": "https://schema.org/Sunday",
                        "opens":  "09:00",
                        "closes":  "18:00"
                      },
                      {
                        "dayOfWeek": "https://schema.org/Monday",
                        "opens":  "09:00",
                        "closes":  "18:00"
                      },
                      {
                        "dayOfWeek": "https://schema.org/Tuesday",
                        "opens":  "09:00",
                        "closes":  "18:00"
                      },
                      {
                        "dayOfWeek": "https://schema.org/Wednesday",
                        "opens":  "09:00",
                        "closes":  "18:00"
                      },
                      {
                        "dayOfWeek": "https://schema.org/Thursday",
                        "opens":  "09:00",
                        "closes":  "13:00"
                      }
                    ],
                    "geo": {
                      "@type": "GeoCoordinates",
                      "latitude": "35.7084268",
                      "longitude": "51.4254784"
                    },
                    "hasMap": "https://www.google.com/maps/place/Arya+samaneh/@35.7084268,51.4254784,15z/data=!4m14!1m7!3m6!1s0x3f8e03d4ca436107:0x14e0491168b7a117!2sArya+samaneh!8m2!3d35.7067106!4d51.4346408!16s%2Fg%2F11bx4l1g5n!3m5!1s0x3f8e03d4ca436107:0x14e0491168b7a117!8m2!3d35.7067106!4d51.4346408!16s%2Fg%2F11bx4l1g5n?entry=ttu"
                  },
                  "addressCountry": {
                    "@type": "Country",
                    "name": "Iran"
                  }
                },
                "potentialAction": [
                  {
                    "@type": "SearchAction",
                    "target": {
                      "@type": "EntryPoint",
                      "urlTemplate": "https://navatel.ir/?s={search_term_string}"
                    },
                    "query-input": "required name=search_term_string"
                  },
                  {
                    "@type": "ReadAction",
                    "target": [
                      "https://navatel.ir/"
                    ]
                  }
                ],
                "sameAs": [
                  "https://linkedin.com/company/mynavatel/",
                  "https://instagram.com/navatel.ir",
                  "https://aparat.com/Navatel"
                ]
              }
            ]
          }
        }
      ],
        link: [
    {
      rel: 'canonical',
      href: "https://navatel.ir"
    }
  ]
    });
  },
})
</script>
